







































import Vue from 'vue';
import { CampaignRecipient } from '@/types';
import InputResultFilter from '@/components/pagination/InputResultFilter.vue';
import LinkInfo from './LinkInfo.vue';
import extract, { getCustomFieldValue } from './customField';

export default Vue.extend({
  props: {
    recipients: {
      type: Array as () => CampaignRecipient[],
      default() {
        return [];
      },
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      maxResults: 10,
    };
  },
  computed: {
    filtered(): CampaignRecipient[] {
      return this.recipients.slice(0, this.maxResults);
    },
    customFields(): string[] {
      return extract(this.recipients);
    },
  },
  methods: {
    getCustomFieldValue,
  },
  components: {
    'link-info': LinkInfo,
    'input-result-filter': InputResultFilter,
  },
});
